<i [ngClass]="iconClass" *ngIf="!tag.color"></i>
<span *ngIf="tag.color" [style.background]="tag.color"></span>

{{tag.name}}
